export interface Pagination {
  page: number;
  limit: number;
  [key: string]: string | number;
}

export const getPagination = (request: Request) => {
  const url = new URL(request.url);
  const allParams = Object.fromEntries(url.searchParams);
  const page = allParams.page ?? "1";
  const limit = allParams.limit ?? "10";
  return { ...allParams, page: Number(page), limit: Number(limit) };
};

export const toUrlSearchParams = (pagination: Pagination) => {
  return new URLSearchParams(
    Object.entries(pagination).map(([key, value]) => [key, value.toString()])
  ).toString();
};

export const DEFAULT_PAGINATION: Pagination = { page: 1, limit: 10 };
export const ALL_PAGINATION: Pagination = { page: 1, limit: 10000 };
